enum AdditionalInfo {
    /**
     * Event sharing from calendar
     */
    EventSharingFromCalendar,

    /**
     * Event sharing from mail
     */
    EventSharingFromMail,

    /**
     * Email reminder
     */
    EmailReminder,
}

export default AdditionalInfo;
